import { ArrowLeft } from '@mui/icons-material'
import { Button, Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { GreenText } from 'components'
import { NeedsClusterRemovedDetailsDto, NeedsToBeMovedToStagingDetailsDto } from 'dtos'
import CheckInReviewItem from '../checkIn/CheckInReviewItem'
import { VehicleNeedsToBeMovedToStagingPhotoProps } from './index'
import NeedsToBeMovedToStagingStepper from './NeedsToBeMovedToStagingStepper'

interface Step3StagingReviewProps extends VehicleNeedsToBeMovedToStagingPhotoProps {
  onBack: () => void
  onNext: () => void
  vehicleNeedsToBeMovedToStagingDetails: NeedsToBeMovedToStagingDetailsDto
  vehicleGuid?: string
}

export default function Step3StagingReview({
  onBack,
  onNext,
  vehicleNeedsToBeMovedToStagingDetails,
  vehicleGuid,
  warrantyCertPhoto,
  setWarrantyCertPhoto
}: Step3StagingReviewProps) {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={12}>
            <NeedsToBeMovedToStagingStepper activeStep={2} />
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <CheckInReviewItem complete={Boolean(warrantyCertPhoto.warrantyCertPhotoFileName)} label='Warranty Certificate In Glovebox' />

          <CheckInReviewItem complete={Boolean(warrantyCertPhoto.parkingSpace)} label={`Parking Space: ${warrantyCertPhoto.parkingSpace ?? '-'}`} />

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <GreenText variant='outlined'>
              {`**Vehicle Check-In Steps:**

Displays the current step of the vehicle in the process.

**Warranty Certificate In Glove Box Check Mark:**

Displays a check mark to indicate that the Warranty Certificate
In Glovebox Photo has been successfully uploaded.

**Parking Space Check Mark:**

Displays a check mark to indicate that a Parking space has
been selected and displays the parking space

**SUBMIT Button:**

Clicking this button will:

Upload the Warranty Certificate In Glovebox and associate it
with the vehicle record, including:

- The name of the user who completed the process.

- A date/time stamp.

Save/Update the vehicles parking space to the selected parking
space.

Return the user to the Needs To Be Moved To Staging to-do list
screen.

**PREVIOUS Button:**

Clicking this button will:

- Return the user to the previous step in the process.

`}
            </GreenText>
          </Grid>

          <Grid item xs={12}>
            <Button color='primary' fullWidth onClick={onNext} type='submit' variant='contained'>
              SUBMIT
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Button color='primary' startIcon={<ArrowLeft />} fullWidth onClick={onBack} variant='outlined'>
              PREVIOUS
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
